import { checkIsInternal } from '@src/utility/createStorage';
import HttpService from '@src/utility/httpService';
import { config } from '@uhg-abyss/web/tools/config';

const _httpService = new HttpService();

const IMPACT_REDIRECT_ENDPOINT = 'pnb/impact-sso';

export interface ImpactRedirectData {
  url: string;
  status: string;
  message: string | null;
}

export interface ImpactRedirectResponse {
  status: string;
  statusCode: number;
  message: string;
  timeStamp: number;
  data: ImpactRedirectData;
}

export const getImpactRedirectUrl = async (params: { genesisId?: string; tin?: string }): Promise<ImpactRedirectResponse> => {
  
    _httpService.setBaseURL(config('PNB_DOMAIN_INTERNAL') || '');
  
  const response: any = await _httpService.push(IMPACT_REDIRECT_ENDPOINT, params);
  return response;
};
